import { JsonService, UtilService, Category} from "@maidi/common";
import request from "@/plugins/axios";
import CacheService from "@/service/catch";

export const  EInstanceState = {
  'Forward' : -3,//审批中
  'Processing' : -1,//审批中
  'Failed' : 0,//拒绝
  'Pass' : 1,//审批通过
  'Discard' : 2,//作废
  'Revoke' : 3,//撤销
}

export const EStepState = {
  'Pending' : -2,  //未开始
  'Processing' : -1,//审批中
  'Failed' : 0,//拒绝
  'Pass' : 1,//审批通过
  'Discard' : 2,//作废
  'Revoke' : 3,//撤销
}





export const SearchOption = {page: 1, pageSize: 30, defId: null, q: "", insState: null, reload: false};



export class InstanceService {

  //保存流程实例
  static save(model) {
    return request.post(`/Crm/WfInstance/SaveWfInstance`, model);
  }

  //获取流程实例
  static info(id) {
    return request.get(`/Crm/WfInstance/WfInstanceInfoById?id=${id}`)
  }

  // 阅读流程实例 更新为通过
  static read(id, step) {
    return request.get(`/Crm/WfInstance/Read?insId=${id}&stepId=${step}`)
  }

  // 审批流程实例
  static approve(id, step, state = 1, opinion = "") {
    return request.post(`/Crm/WfInstance/Approve`, {
      insId:id,
      stepId:step,
      approve:{
        state,
        opinion
      }
    })
  }

  // 撤销流程实例
  static async revoke(id) {
    return await request.post(`/Crm/WfInstance/RevokeWfInstance?insId=${id}`);
  }





}





